// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/images/roll-image.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  flex: 1 1;
  display: flex;
  font-family: "Proxima Nova", sans-serif;
  animation: fadeIn 1s;
  justify-content: space-between;
}
.login-container .login-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
}
.login-container .login-form .header, .login-container .login-form .subheader {
  margin: 0;
}
.login-container .login-form .header {
  font-size: 36px;
  color: var(--secondary-color-1);
  font-weight: 700;
}
.login-container .login-form .subheader {
  font-size: 24px;
  color: var(--secondary-color-3);
  font-weight: 700;
}
.login-container .login-form .forgot-password {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color-1);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.login-container .login-form .sign-up {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: var(--secondary-color-3);
}
.login-container .login-form .sign-up > span {
  padding-left: 10px;
  font-weight: 700;
  color: var(--primary-color-1);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.login-container .scrolling-background-container {
  overflow: hidden;
  height: 100vh;
}
.login-container .scrolling-background-container .scrolling-background {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-y;
  width: 500px;
  height: 5076px;
  animation: slide 90s linear infinite;
}
@keyframes slide {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, -1692px, 0);
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .login-container {
    align-items: center;
    justify-content: center;
  }
  .login-container .login-form > div {
    align-items: center;
    text-align: center;
  }
  .login-container .scrolling-background-container {
    display: none;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .login-container {
    align-items: center;
    justify-content: center;
  }
  .login-container .login-form > div {
    align-items: center;
    text-align: center;
  }
  .login-container .scrolling-background-container {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Authentication/modules/Login/login.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,SAAA;EACA,aAAA;EACA,uCAAA;EACA,oBAAA;EACA,8BAAA;AADJ;AAEI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAAR;AACQ;EACI,SAAA;AACZ;AACQ;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;AACZ;AACQ;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;AACZ;AACQ;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AACZ;AACQ;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AACZ;AAAY;EACI,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAEhB;AAEI;EACI,gBAAA;EACA,aAAA;AAAR;AACQ;EACE,4DAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;AACV;AAEI;EACI;IACI,+BAAA;EAAV;EAEM;IACI,qCAAA;EAAV;AACF;AAEI;EACI;IAAK,UAAA;EACX;EAAM;IAAO,UAAA;EAGb;AACF;;AC9DY;ED+DR;IACI,mBAAA;IACA,uBAAA;EAGN;EADU;IACI,mBAAA;IACA,kBAAA;EAGd;EAAM;IACI,aAAA;EAEV;AACF;ACnFY;EDsFR;IACI,mBAAA;IACA,uBAAA;EAAN;EAEU;IACI,mBAAA;IACA,kBAAA;EAAd;EAGM;IACI,aAAA;EADV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.login-container {\r\n    flex: 1;\r\n    display: flex;\r\n    font-family: 'Proxima Nova', sans-serif;    \r\n    animation: fadeIn 1s;\r\n    justify-content: space-between;\r\n    .login-form {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        height: 100vh;\r\n        .header, .subheader { \r\n            margin: 0;\r\n        }\r\n        .header {\r\n            font-size: 36px;\r\n            color: var(--secondary-color-1);\r\n            font-weight: 700;\r\n        }\r\n        .subheader {\r\n            font-size: 24px;\r\n            color: var(--secondary-color-3);\r\n            font-weight: 700;\r\n        }\r\n        .forgot-password {\r\n            margin: 0;\r\n            font-size: 12px;\r\n            font-weight: 700;\r\n            color: var(--primary-color-1);\r\n            cursor: pointer;\r\n            user-select: none;\r\n        }\r\n        .sign-up {\r\n            margin: 0;\r\n            font-size: 12px;\r\n            font-weight: 400;\r\n            color: var(--secondary-color-3);\r\n            > span {\r\n                padding-left: 10px;\r\n                font-weight: 700;\r\n                color: var(--primary-color-1);\r\n                cursor: pointer;\r\n                user-select: none;\r\n            }\r\n        }\r\n    }\r\n    .scrolling-background-container {\r\n        overflow: hidden;\r\n        height: 100vh;\r\n        .scrolling-background {\r\n          background: url(\"../../../../assets/images/roll-image.png\") repeat-y;\r\n          width: 500px;\r\n          height: 5076px;\r\n          animation: slide 90s linear infinite;\r\n        }\r\n    }\r\n    @keyframes slide{\r\n        0% {\r\n            transform: translate3d(0, 0, 0);\r\n        }\r\n        100% {\r\n            transform: translate3d(0, -1692px, 0);\r\n        }\r\n    }  \r\n    @keyframes fadeIn {\r\n        0% { opacity: 0; }\r\n        100% { opacity: 1; }\r\n    }\r\n}\r\n\r\n@include media(tablet) {\r\n    .login-container {\r\n        align-items: center;\r\n        justify-content: center;\r\n        .login-form {\r\n            > div {\r\n                align-items: center;\r\n                text-align: center;\r\n            }\r\n        }\r\n        .scrolling-background-container { \r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .login-container {\r\n        align-items: center;\r\n        justify-content: center;\r\n        .login-form {\r\n            > div {\r\n                align-items: center;\r\n                text-align: center;\r\n            }\r\n        }\r\n        .scrolling-background-container { \r\n            display: none;\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
